import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-686219b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mega-menu-content" }
const _hoisted_2 = { class: "mega-menu-inner" }
const _hoisted_3 = { class: "mega-menu-left" }
const _hoisted_4 = { class: "mega-menu-title" }
const _hoisted_5 = {
  key: 0,
  class: "mega-menu-list"
}
const _hoisted_6 = { class: "mega-menu-view-all" }
const _hoisted_7 = { class: "mega-menu-right" }
const _hoisted_8 = { class: "mega-image-card__media" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "mega-image-card__label" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { HOME, PRODUCTS } from '@/const/path'

interface MenuNode {
  id?: number | string;
  linkLabel?: string;
  linkTo?: string;
  viewAllTo?: string;
  menuClass?: string;
  icon?: string;
  image?: string;
  urlImage?: string;
  imageBanner?: string;
  children?: MenuNode[];
  [key: string]: any;
}

interface Props {
  megaMenu: MenuNode[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenu',
  props: {
    megaMenu: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const FEATURED_FALLBACKS = computed(() => [
  {
    id: "fallback-1",
    linkLabel: t("text.livingRoom"),
    linkTo: "/",
    image:
      "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=600",
  },
  {
    id: "fallback-2",
    linkLabel: t("text.kitchenIdeas"),
    linkTo: "/",
    image:
      "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=600",
  },
]);

const cardImage = (item: MenuNode) =>
  item.urlImage ||
  item.imageBanner ||
  item.image ||
  (item.icon && /^https?:\/\//.test(String(item.icon)) ? item.icon : "") ||
  FEATURED_FALLBACKS.value[0].image;

const isFeaturedColumn = (item: MenuNode) => {
  const cls = String(item.menuClass || "").toLowerCase();
  if (
    cls.includes("image") ||
    cls.includes("featured") ||
    cls === "megaimage"
  ) {
    return true;
  }
  return Boolean(
    item.urlImage ||
      item.imageBanner ||
      item.image ||
      (item.icon && /^https?:\/\//.test(String(item.icon)))
  );
};

const textColumns = computed(() =>
  (props.megaMenu || []).filter((item) => !isFeaturedColumn(item))
);

const featuredColumns = computed(() => {
  const fromApi = (props.megaMenu || []).filter((item) =>
    isFeaturedColumn(item)
  );
  const fallbacks = FEATURED_FALLBACKS.value;
  if (fromApi.length >= 2) return fromApi.slice(0, 2);
  if (fromApi.length === 1) return [...fromApi, fallbacks[1]];
  return fallbacks;
});

const viewAllLink = computed(() => {
  const cols = textColumns.value;
  const last = cols[cols.length - 1];
  return (
    last?.viewAllTo ||
    last?.linkTo ||
    cols.find((c) => c.linkTo)?.linkTo ||
    PRODUCTS
  );
});

const isEmphasisItem = (child: MenuNode) => {
  const label = String(child.linkLabel || "").toLowerCase();
  return (
    label.includes("mới") ||
    label.includes("new") ||
    child.menuClass === "emphasis" ||
    child.menuClass === "bold"
  );
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "mega-menu-columns",
          style: _normalizeStyle({
            '--mega-cols': Math.max(textColumns.value.length, 1),
          })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(textColumns.value, (column, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `text-${column.id ?? index}`,
              class: _normalizeClass(["mega-menu-column", {
              'mega-menu-column--border':
                index < textColumns.value.length - 1,
            }])
            }, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(column.linkLabel), 1),
              (column.children?.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.children, (child, cIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: child.id ?? cIndex,
                        class: _normalizeClass({
                  'is-emphasis': isEmphasisItem(child),
                })
                      }, [
                        _createVNode(_component_router_link, {
                          to: child.linkTo || _unref(HOME),
                          class: "mega-menu-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(child.linkLabel), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ], 4),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: viewAllLink.value,
            class: "mega-menu-view-all__link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("text.viewAll")), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featuredColumns.value, (card, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: `feat-${card.id ?? index}`,
            to: card.linkTo || _unref(HOME),
            class: "mega-image-card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: cardImage(card),
                  alt: card.linkLabel,
                  loading: "lazy"
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(card.linkLabel), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ])
  ]))
}
}

})